import Vue from 'vue'

const state = {
  roundPrices: {}
}

const getters = {
  priceForRound: (state) => roundId => {
    return state.roundPrices[roundId] || 0
  }
}

const mutations = {
  SET_ROUND_PRICE (state, { id, value }) {
    Vue.set(state.roundPrices, id, value)
  }
}

const actions = {
  setRoundPrice ({ commit }, { id, value }) {
    commit('SET_ROUND_PRICE', { id, value })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
